import { render, staticRenderFns } from "./openReleaseList.vue?vue&type=template&id=5ce96004&scoped=true"
import script from "./openReleaseList.vue?vue&type=script&lang=js"
export * from "./openReleaseList.vue?vue&type=script&lang=js"
import style0 from "./openReleaseList.vue?vue&type=style&index=0&id=5ce96004&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce96004",
  null
  
)

export default component.exports